var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 10.4999H2.66683C2.31321 10.4999 1.97407 10.3594 1.72402 10.1094C1.47397 9.85935 1.3335 9.52021 1.3335 9.16659V3.16659C1.3335 2.81296 1.47397 2.47382 1.72402 2.22378C1.97407 1.97373 2.31321 1.83325 2.66683 1.83325H8.66683C9.02045 1.83325 9.35959 1.97373 9.60964 2.22378C9.85969 2.47382 10.0002 2.81296 10.0002 3.16659V3.83325M7.3335 6.49992H13.3335C14.0699 6.49992 14.6668 7.09687 14.6668 7.83325V13.8333C14.6668 14.5696 14.0699 15.1666 13.3335 15.1666H7.3335C6.59712 15.1666 6.00016 14.5696 6.00016 13.8333V7.83325C6.00016 7.09687 6.59712 6.49992 7.3335 6.49992Z",
    stroke: "#008080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.9346d5d2cc8d15b0f62ce7b95cb1c4b1.svg";
export { ForwardRef as ReactComponent };